import { connectRouter, routerMiddleware } from "connected-react-router";
import { loadUser, reducer as oidcReducer } from "redux-oidc";
import { snackbarReducer } from "react-redux-snackbar";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { History } from "history";
import thunk from "redux-thunk";
import { IAppState } from "../Common";
import { authService } from "../Auth";
import feedbackFormReducer from "../Feedback/Reducers/FeedbackFormReducer";
import feedbackDetailsReducer from "../Feedback/Reducers/FeedbackDetailsReducer";
import FeedbackListReducer from "../Feedback/Reducers/FeedbackListReducer";
import feedbackEditReducer from "../Feedback/Reducers/FeedbackEditReducer";
import feedbackDeleteReducer from "../Feedback/Reducers/FeedbackDeleteReducer";
import autocompleteSearchReducer from "../Layout/Reducers/AutocompleteSearchReducer";
import startupReducer from "./Reducers/StartupReducer";
import appSubscriptionReducer from "../App/Reducers/AppSubscriptionReducer";
import appAssignmentReducer from "../App/Reducers/AppAssignmentReducer";
import userAutocompleteSearchReducer from "../User/Reducers/UserAutocompleteSearchReducer";
import searchContextReducer from "../Layout/Reducers/SearchContextReducer";
import topicSubscriptionReducer from "../Topic/Reducers/TopicSubscriptionReducer";
import advancedSearchReducer from "../Layout/Reducers/AdvancedSearchReducer";
import topicWorkflowReducer from "../Topic/Reducers/TopicWorkflowReducer";
import workflowReducer from "../Workflows/Reducers/WorkflowReducer";
import workflowOptionsReducer from "../Workflows/Reducers/WorkflowOptionsReducer";
import workflowImagesReducer from "../Workflows/Reducers/WorkflowImagesReducer";
import tagsReducer from "../Tags/Reducers/TagReducer";
import userListReducer from "../User/Reducers/UserListReducer";
import triggerReducer from "../Workflows/Reducers/TriggerReducer";

const reducers = {
  oidc: oidcReducer,
  snackbar: snackbarReducer,
  feedbackForm: feedbackFormReducer,
  feedbackDetails: feedbackDetailsReducer,
  feedbackLists: FeedbackListReducer,
  feedbackEdit: feedbackEditReducer,
  feedbackDelete: feedbackDeleteReducer,
  app: startupReducer,
  autocompleteSearch: autocompleteSearchReducer,
  userAutocompleteSearch: userAutocompleteSearchReducer,
  appSubscriptions: appSubscriptionReducer,
  appAssignment: appAssignmentReducer,
  searchContext: searchContextReducer,
  advancedSearch: advancedSearchReducer,
  topicSubscriptions: topicSubscriptionReducer,
  topicWorkflow: topicWorkflowReducer,
  workflow: workflowReducer,
  workflowOptions: workflowOptionsReducer,
  workflowImages: workflowImagesReducer,
  tags: tagsReducer,
  triggers: triggerReducer,
  userList: userListReducer
};

export async function configureStore(history: History, initialState?: IAppState) {
  const middleware = [thunk, routerMiddleware(history)];

  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history)
  });

  const enhancers = [];
  // grab redux devtools extension, this is needed to use the chrome redux extension with middleware
  const windowIfDefined = typeof window === "undefined" ? null : (window as any);

  /* eslint-disable no-underscore-dangle */
  if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
    enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
  }
  /* eslint-enable  no-underscore-dangle */

  const store = createStore(
    rootReducer,
    initialState as any,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  loadUser(store, await authService.getUserManager());

  return store;
}
